// Document DTO and types for client usage
export enum FileCategory {
  Prescription = 1,
  LabReport = 2,
  InsuranceCard = 3,
  MedicalBill = 4,
  DischargeSummary = 5,
  Other = 0,
  Identity = 6,
  EmergencyCard = 7,
} // 'Other' is included for uncategorized/other documents

export enum DocumentStatus {
  Pending = 0,
  Processing = 1,
  Processed = 2,
  Failed = 3,
  Uncategorized = 4,
}

export enum DocumentSource {
  APP = "app",
  WHATSAPP = "whatsapp",
  EMAIL = "email",
  CAMERA = "camera",
  GALLERY = "gallery",
  FILES = "files",
}

export interface Media {
  fileName: string;
  mimeType: string;
  size: string;
  fileKey: string;
  url: string;
  thumbnail?: string;
  uploadTime?: number;
}

export interface Document {
  uid: string;
  category: FileCategory | string;
  media: Media;
  created_at: string;
  status: DocumentStatus | string;
  insights?: boolean;
}

export interface CreateDocumentDto {
  media: Media;
  category: FileCategory;
  status: DocumentStatus;
  tags?: string[];
  notes?: string;
  availableOffline?: boolean;
  isPrivate?: boolean;
  isImportant?: boolean;
  summary?: any;
  insights?: boolean;
  source?: DocumentSource;
}

export const fileCategoryLabels: Record<FileCategory, string> = {
  [FileCategory.Prescription]: "Prescription",
  [FileCategory.DischargeSummary]: "Procedure",
  [FileCategory.LabReport]: "Report",
  [FileCategory.MedicalBill]: "Bill",
  [FileCategory.InsuranceCard]: "Insurance",
  [FileCategory.Identity]: "Identity",
  [FileCategory.Other]: "Other", // For documents not matching other categories
};

export function getFileCategoryLabel(
  category: FileCategory | null | undefined
): string {
  if (category == null) return "All Types";
  return fileCategoryLabels[category as FileCategory] || String(category);
}
